import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

export const useBackHandler = () => {
    const navigate = useNavigate();

    const handleBack = useCallback((fallbackPath: string = '/', forceUrl: boolean = false) => {
        try {
            if (forceUrl) {
                navigate(fallbackPath);
            } else {
                navigate(-1);

                const currentPath = window.location.pathname;
                setTimeout(() => {
                    if (window.location.pathname === currentPath) {
                        navigate(fallbackPath);
                    }
                }, 100);
            }
        } catch (error) {
            window.location.href = fallbackPath;
        }
    }, [navigate]);

    return handleBack;
};
